import styled from 'styled-components';
import { Tag } from '@10d/tend-ui/primitives';

export const TagSelected = styled(Tag)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  height: 100%;
  line-height: 14px;
  margin: 0;
  padding: 1px;
`;

export const LabelSelected = styled.div`
  margin-right: 7px;
`;
